
    import { defineComponent } from "vue";
    import vm from '@/main';
    import { quizModel} from "@/models/WorkspaceModel";
    import SecondNavbar from "@/components/SecondNavbar.vue";
    import WorkspaceQuizApi from "@/apis/WorkspaceQuizApi";

    export default defineComponent({
        name: "QuizWorkspace",
        components: {
            SecondNavbar,
        },
        data() {
            return {
                quizFolder: new Array<quizModel>(),
                searchKeyword: "",
                pages:{
                    pageNumber: 1, // 目前頁碼，從1開始
                    pageSize: 30, // 頁面大小，任意>0
                    totalPages: 3, // 總頁面數，從0開始
                },
                order: "name",
            };
        },
        mounted() {

        },
        methods: {
            changeSort(method: string){
                this.order = method;
                this.searchByname(this.searchKeyword);
            },
            async onPageChange(newPage:number){
                console.log("Debug: onPageChange newPage=.", newPage);
                console.log("Debug: onPageChange buttonSearch keyword= ", this.searchKeyword);
                if(newPage < 1)  newPage = 1;
                else if(newPage > this.pages.totalPages)    newPage = this.pages.totalPages
                this.$store.commit('updateLoading', true);
                this.getQuiz(newPage);
            },
            clearKeyword(){
                console.log("Debug: clearKeyword");
                // this.searchKeyword = "";
                this.searchByname("");
            },
            async searchByname(keyword:string){
                this.searchKeyword = keyword;
                console.log("Debug: buttonSearch keyword= ", this.searchKeyword);
                this.getQuiz(1);
            },
            editQuiz(index:number){
                this.$store.commit('changeQuizWorkspace', this.quizFolder[index]);
                this.$router.push({
                    name: "EditQuiz",
                });
            },
            async deleteQuiz(index:number){
                const courseName = this.quizFolder[index].metadata.name;
                this.$bvModal.msgBoxConfirm(`确定要刪除「${courseName}」吗?`,{
                    title: 'Please Confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: '确定',
                    cancelTitle: '取消',
                    footerClass: 'p-2',
                    hideHeaderClose: true,
                    centered: true
                })
                .then(async value => {
                if(value) {
                    const userConfirmation = prompt("确认要刪除吗？（输入“确认刪除”进行刪除）");
                    console.log("userConfirmation: " + userConfirmation);
                    if(userConfirmation == null){
                        return false;
                    }
                    else if (userConfirmation !== "确认刪除") {
                        alert("輸入錯誤")
                        this.deleteQuiz(index);
                        return false;
                    }
                    else{
                        try{
                            this.$store.commit('updateLoading', true);
                            await WorkspaceQuizApi.deleteQuiz(this.quizFolder[index].uuid);
                            // this.quizFolder.splice(index, 1);
                            this.getQuiz(this.pages.pageNumber);
                            alert("刪除成功")
                        }
                        catch(e){
                            console.log(e);
                        }
                        finally{
                            this.$store.commit('updateLoading', false);
                        }
                    }
                }
                })
                .catch(err => {
                // An error occurred
                })
            },
            async getQuiz(page: number){
                this.$store.commit('updateLoading', true);
                try{
                    const quizQueryResult = JSON.parse(JSON.stringify(await WorkspaceQuizApi.getQuizByName(this.searchKeyword ,page, this.order)));
                    this.quizFolder = quizQueryResult.results.results;
                    this.pages.totalPages = quizQueryResult.results.totalPages;
                    this.pages.pageNumber = quizQueryResult.results.pageNumber;
                }
                catch(e){
                    console.log(e);
                }
                finally{
                    this.$store.commit('updateLoading', false);
                }
            },
        },

        async created(){
            this.getQuiz(1)
        }
    });
